import * as React from 'react';
import { OverstepPageState } from './types';
import normalizeOverstepPageData from './normalizeOverstepPageData';
import { useFetchAPI } from '@ids/hooks';
import { IDSOverstepPageResponse } from '@ids/types/now-api';

const initialOverstepPageState = {
    data: null,
    errors: null,
    success: false,
    loading: false,
};

const OverstepPageContext = React.createContext<OverstepPageState>(initialOverstepPageState);
OverstepPageContext.displayName = 'OverstepPageContext';

export const OverstepPageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { data } = useFetchAPI<IDSOverstepPageResponse>('web/v1/content/entries/newIdsOverstepPage');

    const ctxValue: OverstepPageState = React.useMemo(
        () => ({
            data: normalizeOverstepPageData(data),
            errors: data?.errors || null,
            success: !!data?.success,
            loading: !!(!data?.data?.length && !data?.success && (!data?.errors?.length || !data?.errors)),
        }),
        [data]
    );
    return <OverstepPageContext.Provider value={ctxValue}>{children}</OverstepPageContext.Provider>;
};

export const useOverstepPageContext = () => {
    const context = React.useContext(OverstepPageContext);

    // istanbul ignore next
    if (Object.keys(context).length === 0) {
        throw new Error('useOverstepPageContext must be used within a OverstepPageContextProvider');
    }

    return context;
};
